import React from 'react';
import { Interactable } from 'LocalGluons';
import { Text } from 'react-native';
import styles from './styles';
import type { LanguageSelectorProps } from '../LanguageSelector';

export interface LanguageButtonProps {
    label: string;
    isSelected: boolean;
    onSelect: LanguageSelectorProps['onSelect'];
}

const LanguageButton = ({ label, isSelected, onSelect }: LanguageButtonProps): JSX.Element => (
    <Interactable style={styles.languageButton} onPress={() => onSelect(label)}>
        <Text style={[styles.languageButtonLabel, isSelected && styles.selectedLabel]}>
            {label}
        </Text>
    </Interactable>
);

export default LanguageButton;
export { LanguageButton };
